import {h} from 'preact';
import {useState} from 'preact/hooks';
import constants from "../constants";
import {ToastPosMenuImport} from "./ToastPosMenuImport";
import {SquarePosMenuImport} from "./SquarePosMenuImport";
import {TreezPosMenuImport} from "./TreezPosMenuImport";
import {PopmenuPosMenuImport} from "./PopmenuPosMenuImport";

const posProviders = {
  [constants.IMPORT_SOURCE_TOAST]: 'Toast',
  [constants.IMPORT_SOURCE_CLOVER]: 'Clover',
  [constants.IMPORT_SOURCE_SQUARE]: 'Square',
  [constants.IMPORT_SOURCE_TREEZ]: 'Treez',
  [constants.IMPORT_SOURCE_POPMENU]: 'Popmenu',
}

export function PosMenuImport(props) {
  const [provider, setProvider] = useState(props.isClover ? constants.IMPORT_SOURCE_CLOVER : (props.isSquare ? constants.IMPORT_SOURCE_SQUARE : (props.isTreez ? constants.IMPORT_SOURCE_TREEZ : (props.isPopmenu ? constants.IMPORT_SOURCE_POPMENU : constants.IMPORT_SOURCE_TOAST))));

  return <div>
    {!provider && <div className={"pos-menu"}>
      <div className={'wrapper'}>
        <span className={'choose'}>Choose a POS Service:</span>
        <div className={'providers'}>
          {Object.keys(posProviders).map(it => <div key={it} onClick={() => setProvider(it)}>{posProviders[it]}</div>)}
        </div>
      </div>
    </div>}
    {provider === constants.IMPORT_SOURCE_TOAST && <ToastPosMenuImport {...props} /> }
    {provider === constants.IMPORT_SOURCE_SQUARE && <SquarePosMenuImport {...props}/>}
    {provider === constants.IMPORT_SOURCE_TREEZ && <TreezPosMenuImport {...props}/>}
    {provider === constants.IMPORT_SOURCE_POPMENU && <PopmenuPosMenuImport {...props}/>}
  </div>
}
